import { gql, useMutation } from '@apollo/client';

export const UPDATE_TRANSACTION_STATUS_MUTATION = gql`
  mutation UpdateTransactionStatus($transactionIds: [Int!]!, $status: String!) {
    poSaleOrder {
      updateTransactionStatus(transactionIds: $transactionIds, status: $status) {
        success
        message {
          code
          message
        }
        content
      }
    }
  }
`;

export const useUpdateTransactionStatusMutation = () => {
  return useMutation(UPDATE_TRANSACTION_STATUS_MUTATION);
};

